import React, { Component } from "react";
import Man from "./man.jpg";
class FeelingProud extends Component {
  render() {
    return <img src={Man} alt="" />;
  }
}

export default FeelingProud;
